<div class="bottom-paginator flex align-items-center" [ngClass]="enablePagination ? '' : 'disabled'">
  <div
    class="min-w-full m-0 flex flex-row gap-2 justify-content-center align-items-center"
  >
    <!-- First Page -->
    <p-button
      (click)="onNavigate.emit({action: 'first'})"
      [disabled]="gPage.previousIsDisabled()"
      [icon]="'fa fa-backward-step'"
      [styleClass]="'n-button-icon'"
      [raised]="true"
    >
    </p-button>
    <!-- Previous Page -->
    <p-button
      (click)="onNavigate.emit({action: 'prev'})"
      [disabled]="gPage.previousIsDisabled()"
      [styleClass]="'n-button-icon'"
      [icon]="'fa fa-backward'"
      [raised]="true"
    >
    </p-button>
    <!-- Page Selector -->
    <p-dropdown
      [options]="gPage.combo"
      optionLabel="key"
      optionLabel="value"
      (onChange)="changePageFromDropdown($event.value)"
      [(ngModel)]="currentComboPageIndex"
      [styleClass]="'dropdown-paginator'"
    ></p-dropdown>

    <!-- Next Page -->
    <p-button
      [styleClass]="'n-button-icon'"
      (click)="onNavigate.emit({action: 'next'})"
      [disabled]="gPage.nextIsDisabled()"
      [icon]="'fa fa-forward'"
      [raised]="true"
    >
    </p-button>
    <!-- Last Page -->
    <p-button
      (click)="onNavigate.emit({action: 'last'})"
      [disabled]="gPage.nextIsDisabled()"
      [icon]="'fa fa-forward-step'"
      [styleClass]="'n-button-icon'"
      [raised]="true"
    >
    </p-button>
    <!-- Add Page -->
    <p-button
      (click)="addPage()"
      [icon]="'fa fa-file-circle-plus'"
      [styleClass]="'n-button-icon'"
      [raised]="true"
    >
    </p-button>

    <!-- Add Page Menu -->
    <p-button
      (onClick)="addPageMenu.toggle($event)"
      [icon]="'fa fa-ellipsis-vertical'"
      [styleClass]="'n-button-icon'"
      [raised]="true"
    >
    </p-button>
    <p-overlayPanel #addPageMenu appendTo="body">
      <div class="flex flex-column gap-3" style="width: 280px">

        <span class="text-xs font-semibold text-color-secondary uppercase">
          {{ "PAGE.ADDPAGE" | translate }}
        </span>

        <div class="flex flex-row gap-2">
          <div class="flex-1">
            <p-button
              (click)="addPageFirst(); addPageMenu.hide()"
              size="small"
              icon="fa fa-backward-step"
              label="{{ 'PAGE.ADDTOFIRST' | translate }}"
              severity="secondary"
              [outlined]="true"
              styleClass="w-full"
            ></p-button>
          </div>
          <div class="flex-1">
            <p-button
              (click)="addPage(); addPageMenu.hide()"
              size="small"
              icon="fa fa-forward-step"
              label="{{ 'PAGE.ADDTOLAST' | translate }}"
              iconPos="right"
              severity="secondary"
              [outlined]="true"
              styleClass="w-full"
            ></p-button>
          </div>
        </div>

        <p-divider styleClass="my-0"></p-divider>

        <div class="flex flex-column gap-2" (click)="$event.stopPropagation()">
          <div style="display: grid; grid-template-columns: 1fr auto auto; align-items: center; gap: 0.5rem;">
            <label class="text-sm white-space-nowrap">{{ "PAGE.ADDBEFORE" | translate }}</label>
            <p-dropdown
              [options]="currentNumberPages"
              [(ngModel)]="pageBefore"
              [styleClass]="'dropdown-paginator'"
            ></p-dropdown>
            <p-button
              (click)="addPageBefore(pageBefore); addPageMenu.hide()"
              icon="fa fa-plus"
              size="small"
              severity="secondary"
              [outlined]="true"
            ></p-button>
          </div>

          <div style="display: grid; grid-template-columns: 1fr auto auto; align-items: center; gap: 0.5rem;">
            <label class="text-sm white-space-nowrap">{{ "PAGE.ADDNEXTTO" | translate }}</label>
            <p-dropdown
              [options]="currentNumberPages"
              [(ngModel)]="pageAfter"
              [styleClass]="'dropdown-paginator'"
            ></p-dropdown>
            <p-button
              (click)="addPageAfter(pageAfter); addPageMenu.hide()"
              icon="fa fa-plus"
              size="small"
              severity="secondary"
              [outlined]="true"
            ></p-button>
          </div>
        </div>

      </div>
    </p-overlayPanel>
  </div>
</div>
